export default __webpack_public_path__ + "static/media/Intro_img.0919761a.png";